import React from 'react';

import CommonTooltipEllipses from '../../../../common-tooltip-ellipses/CommonTooltipEllipses';

import scss from './VerticalBarTooltipLabels.module.scss';

function VerticalBarTooltipLabels({ labels }) {
  return (
    <div className={scss.wrapper} style={{ gridTemplateColumns: `repeat(${labels.length}, minmax(0, 1fr))` }}>
      {labels.map((label, index) => (
        <div key={`${label}-${index}`} className={scss.item}>
          <CommonTooltipEllipses toolTipText={label} label={label} className={scss.itemLabel} maxRows={2} wordWrap />
        </div>
      ))}
    </div>
  );
}

export default VerticalBarTooltipLabels;
